var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.675,
    y: 4.81641,
    width: 8.11172,
    height: 18.2204,
    transform: "rotate(30 10.675 4.81641)",
    fill: "#151515"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00597 21.5809L7.93604 25.6048L-5.72205e-06 30.6348L1.00597 21.5809Z",
    fill: "#151515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3125 7.94422L21.5731 9.24939L17.3077 16.6374L15.047 15.3322L19.3125 7.94422Z",
    fill: "#151515"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1561 0.44725C13.403 0.0195597 13.9499 -0.126977 14.3776 0.11995L19.8538 3.28161C20.2814 3.52853 20.428 4.07542 20.1811 4.50311L18.2024 7.93017L11.1775 3.87431L13.1561 0.44725Z",
    fill: "#151515"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6968 3.24966L22.6534 7.42284L21.2638 9.73921L14.3072 5.56603L15.6968 3.24966Z",
    fill: "#151515"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1927 23.8117C22.7967 26.642 21.6705 28.4604 20.0888 29.8977L19.1361 30.7634L18.4126 29.6988C17.7272 28.6904 17.4018 27.2737 17.2613 25.938C17.2178 26.008 17.1743 26.0778 17.1308 26.1473C16.1848 27.6573 15.1474 29.1406 14.4267 29.8611L13.5884 30.699L12.801 29.8131C12.3423 29.297 12.0249 28.6411 11.7987 28.0161C11.6592 27.6308 11.545 27.2305 11.4517 26.8375C9.96545 28.6941 8.16971 29.9398 6.68491 30.5512L5.83374 28.4841C7.48971 27.8022 9.83843 25.9844 11.1597 23.0785L13.2751 23.751C13.2832 23.7085 13.2853 23.6816 13.2856 23.6816C13.286 23.6817 13.284 23.7147 13.2855 23.7961C13.2874 23.907 13.2945 24.0637 13.3092 24.2567C13.3386 24.6426 13.3964 25.1471 13.4938 25.6833C13.5786 26.1505 13.6906 26.6255 13.8331 27.0591C14.258 26.4722 14.7428 25.7482 15.2364 24.9604C16.1726 23.4662 17.0595 21.8728 17.5309 20.7975L19.6389 21.5177C19.4784 22.1587 19.3486 23.5168 19.4265 24.9664C19.4672 25.7243 19.5614 26.4331 19.7061 27.0374C21.0392 25.3486 22.2073 22.867 24.358 18.207L26.4765 18.8529C25.7394 23.4364 26.9504 27.0018 29.0792 29.1843L27.4789 30.7452C25.7662 28.9893 24.606 26.6181 24.1927 23.8117Z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignature);
export default __webpack_public_path__ + "static/media/signature.30dc2ca0d6f4cca01e9eaf99a9b3c454.svg";
export { ForwardRef as ReactComponent };